export default __webpack_public_path__ + "static/media/loader.ee76d033.svg";